<!--赖传峰-->
<!--2022/12/29-->
<script lang="ts" setup>
import { sleep, watch } from '#imports'
import BaseSorter from '@/components/share/BaseSorter.vue'
import { useShare } from '@/store/share'
import NProgress from 'nprogress'
import useDisplayMode from '~/composables/useDisplayMode'

const { loadShareData = () => {}, showShim = false } = defineProps<{
  loadShareData?: () => void | Promise<void>
  showShim?: boolean
}>()

const emits = defineEmits<{ afterSort: [] }>()

const fileStore = useShare()
const { orderType, pinFoldersTop } = useDisplayMode()

watch([orderType, pinFoldersTop], async () => {
  if (loadShareData) {
    await sleep(30)
    NProgress.start()
    await loadShareData()
    NProgress.done()
  }
})
</script>
<template>
  <BaseSorter
    :default-order-type="fileStore.tempOrder"
    :show-shim="showShim"
    :use-default-order-type="!orderType"
    @after-sort="emits('afterSort')"
  />
</template>
